var _path, _path2, _path3, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransformArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400px",
    height: "200px",
    viewBox: "0 0 400 200",
    enableBackground: "new 0 0 400 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.0249,
    y1: 154.7363,
    x2: 264.5156,
    y2: 142.9434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0569,
    style: {
      stopColor: "#CBD5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    style: {
      stopColor: "#BCD1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2133,
    style: {
      stopColor: "#A3C99C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3029,
    style: {
      stopColor: "#80BF86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    style: {
      stopColor: "#48B469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    style: {
      stopColor: "#00AA4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007736"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M24.071,165.595l-12.029-8.962c0.054-0.072,1.359-1.822,3.786-4.904l11.785,9.279 C25.326,163.912,24.083,165.578,24.071,165.595z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.4082,
    y1: 98.106,
    x2: 265.2148,
    y2: 86.0999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0569,
    style: {
      stopColor: "#CBD5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    style: {
      stopColor: "#BCD1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2133,
    style: {
      stopColor: "#A3C99C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3029,
    style: {
      stopColor: "#80BF86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    style: {
      stopColor: "#48B469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    style: {
      stopColor: "#00AA4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007736"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M35.135,151.71l-11.548-9.572c2.571-3.102,5.251-6.266,7.968-9.406l11.344,9.814 C40.251,145.606,37.639,148.689,35.135,151.71z M356.499,156.938c-1.643-3.552-10.158-23.102-11.961-26.651l13.373-6.793 c1.886,3.712,10.963,24.599,12.684,28.317L356.499,156.938z M50.851,133.537l-11.146-10.039c2.752-3.056,5.557-6.107,8.335-9.069 l10.939,10.263C56.271,127.58,53.536,130.556,50.851,133.537z M338.959,119.786c-1.935-3.485-3.939-6.942-5.96-10.275 l12.828-7.775c2.118,3.495,4.22,7.119,6.247,10.77L338.959,119.786z M67.286,116.017L56.56,105.53 c2.888-2.954,5.819-5.888,8.711-8.721l10.496,10.715C72.952,110.282,70.099,113.14,67.286,116.017z M326.651,99.495 c-2.204-3.323-4.476-6.591-6.753-9.714l12.121-8.837c2.406,3.301,4.807,6.753,7.132,10.259L326.651,99.495z M84.428,99.231 L74.181,88.277c3.022-2.828,6.09-5.628,9.119-8.325l9.975,11.203C90.337,93.771,87.361,96.488,84.428,99.231z M102.312,83.321 l-9.671-11.467c3.195-2.694,6.418-5.334,9.581-7.845l9.328,11.747C108.502,78.176,105.395,80.721,102.312,83.321z M312.723,80.423 c-2.495-3.091-5.06-6.099-7.622-8.939l11.139-10.047c2.745,3.043,5.489,6.261,8.155,9.564L312.723,80.423z M120.993,68.499 l-8.943-12.042c3.376-2.508,6.778-4.942,10.11-7.234l8.502,12.357C127.478,63.771,124.225,66.098,120.993,68.499z M297.006,63.04 c-2.817-2.76-5.705-5.399-8.582-7.845l9.715-11.429c3.145,2.673,6.295,5.552,9.363,8.557L297.006,63.04z M140.567,55.052 l-7.993-12.693c3.583-2.256,7.192-4.417,10.729-6.421l7.398,13.049C147.365,50.877,143.956,52.918,140.567,55.052z M279.338,48.06 c-3.159-2.278-6.385-4.395-9.589-6.291l7.641-12.908c3.591,2.125,7.198,4.492,10.722,7.032L279.338,48.06z M161.076,43.451 l-6.699-13.421c3.831-1.912,7.68-3.693,11.443-5.293l5.872,13.803C168.207,40.022,164.635,41.674,161.076,43.451z M259.679,36.465 c-3.46-1.599-6.994-3.003-10.504-4.172l4.738-14.231c4.038,1.344,8.096,2.955,12.061,4.788L259.679,36.465z M182.535,34.361 l-4.883-14.183c4.105-1.414,8.218-2.647,12.223-3.668l3.703,14.536C189.969,31.966,186.253,33.081,182.535,34.361z  M238.327,29.381c-3.658-0.749-7.39-1.277-11.093-1.571l1.186-14.953c4.313,0.342,8.658,0.957,12.916,1.829L238.327,29.381z  M204.769,28.741l-2.305-14.822c1.949-0.303,3.911-0.561,5.833-0.767c2.355-0.252,4.738-0.43,7.083-0.53l0.639,14.986 c-2.027,0.086-4.088,0.241-6.127,0.458C208.207,28.248,206.483,28.474,204.769,28.741z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.9712,
    y1: 169.46,
    x2: 265.4619,
    y2: 157.667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0569,
    style: {
      stopColor: "#CBD5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    style: {
      stopColor: "#BCD1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2133,
    style: {
      stopColor: "#A3C99C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3029,
    style: {
      stopColor: "#80BF86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    style: {
      stopColor: "#48B469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    style: {
      stopColor: "#00AA4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007736"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M356.499,156.938c-0.006-0.016-0.714-1.95-2.087-5.28l13.865-5.721 c1.51,3.658,2.285,5.785,2.317,5.874L356.499,156.938z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.2119,
    y1: 126.5293,
    x2: 262.7026,
    y2: 114.7363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0569,
    style: {
      stopColor: "#CBD5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    style: {
      stopColor: "#BCD1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2133,
    style: {
      stopColor: "#A3C99C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3029,
    style: {
      stopColor: "#80BF86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    style: {
      stopColor: "#48B469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    style: {
      stopColor: "#00AA4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007736"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_4_)",
    points: "377.469,173.729 238.437,135.317 242.431,120.858 363.777,154.384 371.631,41.367  386.596,42.407  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformArrow);
export default __webpack_public_path__ + "static/media/transform-arrow.104bbef9a536317fd8335e94769cc805.svg";
export { ForwardRef as ReactComponent };